import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type AddressesByPostcodeQueryVariables = Types.Exact<{
    postcode: Types.Scalars['String'];
}>;

export type AddressesByPostcodeQuery = { __typename?: 'Query' } & {
    addressesByPostcode?: Types.Maybe<
        { __typename?: 'AddressesByPostcode' } & {
            addresses: Array<
                Types.Maybe<
                    { __typename?: 'Address' } & Pick<
                        Types.Address,
                        'uprn' | 'postcode' | 'fullAddress'
                    >
                >
            >;
        }
    >;
};

export const AddressesByPostcodeDocument = gql`
    query addressesByPostcode($postcode: String!) {
        addressesByPostcode(postcode: $postcode) {
            addresses {
                uprn
                postcode
                fullAddress
            }
        }
    }
`;

/**
 * __useAddressesByPostcodeQuery__
 *
 * To run a query within a React component, call `useAddressesByPostcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressesByPostcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressesByPostcodeQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useAddressesByPostcodeQuery(
    baseOptions: Apollo.QueryHookOptions<
        AddressesByPostcodeQuery,
        AddressesByPostcodeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        AddressesByPostcodeQuery,
        AddressesByPostcodeQueryVariables
    >(AddressesByPostcodeDocument, options);
}
export function useAddressesByPostcodeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        AddressesByPostcodeQuery,
        AddressesByPostcodeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        AddressesByPostcodeQuery,
        AddressesByPostcodeQueryVariables
    >(AddressesByPostcodeDocument, options);
}
export type AddressesByPostcodeQueryHookResult = ReturnType<
    typeof useAddressesByPostcodeQuery
>;
export type AddressesByPostcodeLazyQueryHookResult = ReturnType<
    typeof useAddressesByPostcodeLazyQuery
>;
export type AddressesByPostcodeQueryResult = Apollo.QueryResult<
    AddressesByPostcodeQuery,
    AddressesByPostcodeQueryVariables
>;
